/* eslint-disable import/prefer-default-export */
import { lazy } from 'react';

export const StockPopUpBuySell = lazy(() =>
  import(/* webpackChunkName: "stock-buy-sell-v2", webpackPrefetch: true */ './StockPopUpBuySell')
);
